import {createSelector} from 'reselect';

export const getMaterialityByIdSlice = (state) => state.materiality.byId;
export const getAllMateriality = createSelector([getMaterialityByIdSlice], (materialityById) => {
	return Object.values(materialityById ?? {});
});
export const getCurrentMateriality = createSelector([getMaterialityByIdSlice], (materialityById) => {
	return Object.values(materialityById)?.find((materiality) => materiality.isCurrent && !materiality.isPriorYear);
});

export const getPriorYearMateriality = createSelector([getMaterialityByIdSlice], (materialityById) => {
	return Object.values(materialityById)?.find((materiality) => materiality.isCurrent && materiality.isPriorYear);
});

// For Print
export const getMaterialityForPrint = (state) => state.formPrintData?.materiality;

export const getCurrentMaterialityforPrint = createSelector([getMaterialityForPrint], (materiality) => {
	return Object.values(materiality)?.find((materiality) => materiality.isCurrent && !materiality.isPriorYear);
});

export const getPriorYearMaterialityForPrint = createSelector([getMaterialityForPrint], (materiality) => {
	return Object.values(materiality)?.find((materiality) => materiality.isCurrent && materiality.isPriorYear);
});
